import React, { useState, useEffect } from "react";
import styles from "./index.module.less";
import bannerImage from "@/assets/images/banner.png";
import {
  windowsUrl,
  macUrl,
  windowsFileName,
  macFileName,
} from "@/utils/constants.js";

import macImage from "@/assets/images/mac.png";
import windowsImage from "@/assets/images/windows.png";
import iosImage from "@/assets/images/ios.png";
import androidImage from "@/assets/images/android.png";
import downloadImage from "@/assets/images/download.png";

import androidCodeImg from "@/assets/images/android_code.png";
import iosCodeImg from "@/assets/images/ios_code.png";

export default function (props) {
  const [downloadIcons, setDownloadIcons] = useState([
    false,
    false,
    false,
    false,
  ]);

  const [icons, setIcons] = useState([
    {
      id: 1,
      icon: macImage,
      desc: "Mac桌面版",
      hoverdedIcon: downloadImage,
      hoverdedDesc: "下载V1.4.0",
    },
    {
      id: 2,
      icon: windowsImage,
      desc: "Windows桌面版",
      hoverdedIcon: downloadImage,
      hoverdedDesc: "下载V1.4.0",
    },
    {
      id: 3,
      icon: iosImage,
      desc: "iOS预览版",
      hoverdedIcon: iosCodeImg,
      hoverdedDesc: "扫描下载V9.1.0",
    },
    {
      id: 4,
      icon: androidImage,
      desc: "Android预览版",
      hoverdedIcon: androidCodeImg,
      hoverdedDesc: "扫描下载V9.1.0",
    },
  ]);

  const showDownloadIcons = (id) => {
    downloadIcons[id] = true;
    setDownloadIcons([...downloadIcons]);
  };
  const hideDownloadIcons = (id) => {
    downloadIcons[id] = false;
    setDownloadIcons([...downloadIcons]);
  };

  /**
   * 下载ZIP包
   * @returns
   */
  const handleDownloadImage = (id) => {
    let zipUrl = "";
    let fileName = "";
    if (id == 1) {
      // Mac
      zipUrl = macUrl;
      fileName = macFileName;
    } else if (id == 2) {
      // Windows
      zipUrl = windowsUrl;
      fileName = windowsFileName;
    } else {
      console.log("id", id);
      return;
    }

    const a = document.createElement("a");
    a.href = zipUrl;
    a.setAttribute("download", fileName);
    a.click();
  };

  return (
    <div className={styles.main}>
      <img className={styles.banner} src={bannerImage} />
      <div className={styles.icon}>
        {icons.map((item) => (
          <div
            className={styles["icon-item"]}
            key={item.id}
            onMouseEnter={() => showDownloadIcons(item.id)}
            onMouseLeave={() => hideDownloadIcons(item.id)}
            onClick={() => handleDownloadImage(item.id)}
          >
            {downloadIcons[item.id] ? (
              <>
                <img src={item.hoverdedIcon} />
                <span>{item.hoverdedDesc}</span>
              </>
            ) : (
              <>
                <img src={item.icon} />
                <span>{item.desc}</span>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
